var selectableGroupInit = function () {
    var checkedRadioInput = $('[data-id="form-selectable-group"] input:checked'),
        showOrHide = function (radioInput) {
            var ele;
            if (radioInput.hasAttr('data-show')) {
                ele = islington.
                    dataIdElement(radioInput.data('show'));
                ele.showWithEnabledFields();
            } else if (radioInput.hasAttr('data-hide')) {
                ele = islington.
                   dataIdElement(radioInput.data('hide'));
                ele.hideWithDisabledFields();
            }
        };

    showOrHide(checkedRadioInput);

    $('[data-id="form-selectable-group"] input').
    on('change', function () {
        var _self = $(this);
        showOrHide(_self);        
    });
};